var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { PAGE } from '../../../renderers/shared/pageTypes';
/**
* Add template page support to pages.
*/
export default function pageMigrations(pages) {
    var newPages = {};
    Object.keys(pages).forEach(function (id) {
        var newPage = __assign({}, pages[id]); // Migrate from version undefined to version 1.
        // Introduction of template page support.
        if (!newPage.version) {
            // Increment version
            newPage.version = 1; // Change the rootLayoutItemId string to an array of rootLayoutItemIds.
            if (newPage.rootLayoutItemId) {
                newPage.rootLayoutItemIds = [newPage.rootLayoutItemId];
                delete newPage.rootLayoutItemId;
            } // Add the type property onto pages if it doesnt exist.
            if (!newPage.type) {
                newPage.type = PAGE;
            }
        } // Update the page in the object.
        newPages[id] = newPage;
    });
    return newPages;
}
